import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FaShareAlt, FaCheck } from 'react-icons/fa';

/**
 * Usa la Web Share API nativa cuando está disponible (móvil);
 * si no, copia el enlace al portapapeles como respaldo.
 */
function ShareButton({ title, text, url, className }) {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, text, url });
      } catch (err) {
        // El usuario canceló el diálogo de compartir; no hacer nada.
      }
      return;
    }

    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <button
      type="button"
      onClick={handleShare}
      className={className}
      aria-label="Compartir esta página"
    >
      {copied ? <FaCheck /> : <FaShareAlt />}
      {copied ? 'Enlace copiado' : 'Compartir'}
    </button>
  );
}

ShareButton.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  url: PropTypes.string.isRequired,
  className: PropTypes.string
};

ShareButton.defaultProps = {
  className: 'inline-flex items-center gap-2 text-sm font-semibold'
};

export default ShareButton;
